import { UNSTABLE_ToastRegion as AriaToastRegion } from 'react-aria-components';
import { QueuedToast, ToastQueue } from 'react-stately';
import { tv } from 'tailwind-variants';
import type { ToastProps } from './ClarionToaster';
import { ClarionToastComponent } from './Toast';

export type ClarionToastRegionProps = {
  queue: ToastQueue<ToastProps>;
  className?: string;
};

const toastRegionStyles = tv({
  base: [
    'fixed top-0 right-0 z-50',
    'flex flex-col gap-0 px-4',
    'max-w-sm md:w-full',
    'pointer-events-none',
  ],
});

export function ClarionToastRegion({ queue, className }: ClarionToastRegionProps) {
  const handleClose = (key: string) => queue.close(key);

  return (
    <AriaToastRegion
      queue={queue}
      className={toastRegionStyles({ className })}
      aria-label="Notifications"
    >
      {({ toast }: { toast: QueuedToast<ToastProps> }) => (
        <ClarionToastComponent key={toast.key} toast={toast} onClose={handleClose} />
      )}
    </AriaToastRegion>
  );
}
